const { VUE_APP_API_SERVER_HOST, VUE_APP_API_SERVER_PORT } = process.env;

export const API_SERVER_HOST: string = String(VUE_APP_API_SERVER_HOST).replace(/\/$/, '');
export const API_SERVER_PORT: string = String(VUE_APP_API_SERVER_PORT);
export const API_SERVER_BASE_URL: string = `${API_SERVER_HOST}:${API_SERVER_PORT}`;

export const ENDPOINT_ROOT: string = 'api';
export const ENDPOINTS = Object.freeze({
  V1: Object.freeze({
    REFRESH_TOKEN: 'token/refresh/',
  }),
});

export const TIMEOUT = 20000;

export const AUTO_REFRESH_TARGET_STATUS_CODES = [401];
